// extracted by mini-css-extract-plugin
export default {"info":"ContactOverlayForm_info__Bl2d8"};